import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const Wrapper = styled.div`
  position: relative;
  z-index: ${props => props.theme.zDefault};
  & > * {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

export const Media = styled.div<{ transition: boolean }>`
  z-index: ${props => props.theme.zDefault};
  opacity: 0;
  transition: ${props => (props.transition ? "opacity 500ms" : undefined)};
`;

export const Spinner = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: ${px2rem(20)};
  height: ${px2rem(20)};
  display: flex;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const BlurHash = styled.div`
  z-index: ${props => props.theme.zBelow};
`;
